<v-container fluid>
  <div class="mb-1">
    <h2 class="text-h5 font-weight-bold">Dashboard</h2>
    <div class="text-body-2 text-medium-emphasis">Benvenuto nel Sistema
      Manutenzione Macchine</div>
  </div>

  <template v-if="kpi">
    <!-- Banner avvisi -->
    <v-alert v-if="kpi.manutenzioniScadute > 0" type="error" variant="tonal" class="my-3 rounded-lg"
      density="comfortable">
      <div class="d-flex align-center justify-space-between flex-wrap" style="gap:8px">
        <span>
          {{ kpi.manutenzioniScadute }}
          manutenzion{{ kpi.manutenzioniScadute === 1 ? 'e scaduta richiede' :
          'i scadute richiedono' }}
          attenzione immediata
        </span>
        <v-btn size="small" color="error" variant="flat" @click="vaiCalendario">Visualizza</v-btn>
      </div>
    </v-alert>

    <v-alert v-if="kpi.manutenzioniPreviteOggi > 0" type="warning" variant="tonal" class="mb-4 rounded-lg"
      density="comfortable">
      <div class="d-flex align-center justify-space-between flex-wrap" style="gap:8px">
        <span>
          {{ kpi.manutenzioniPreviteOggi }}
          manutenzion{{ kpi.manutenzioniPreviteOggi === 1 ? 'e prevista' : 'i previste' }}
          per oggi
        </span>
        <v-btn size="small" color="warning" variant="flat" @click="vaiCalendario">Visualizza</v-btn>
      </div>
    </v-alert>

    <v-alert v-if="kpi.macchineInManutenzione > 0" type="info" variant="tonal" class="mb-4 rounded-lg"
      density="comfortable">
      <div class="d-flex align-center justify-space-between flex-wrap" style="gap:8px">
        <span>
          {{ kpi.macchineInManutenzione }}
          macchin{{ kpi.macchineInManutenzione === 1 ? 'a è in manutenzione' : 'e sono in manutenzione' }}
        </span>
        <v-btn size="small" color="info" variant="flat" @click="vaiMacchine">Visualizza</v-btn>
      </div>
    </v-alert>

    <v-alert v-if="kpi.manutenzioniProssimi7Giorni > 0" type="info" variant="tonal" class="mb-4 rounded-lg"
      density="comfortable">
      <div class="d-flex align-center justify-space-between flex-wrap" style="gap:8px">
        <span>
          {{ kpi.manutenzioniProssimi7Giorni }}
          manutenzion{{ kpi.manutenzioniProssimi7Giorni === 1 ?
          'e pianificata nei' : 'i pianificate nei' }}
          prossimi 7 giorni
        </span>
        <v-btn size="small" color="info" variant="flat" @click="vaiCalendario">Pianifica</v-btn>
      </div>
    </v-alert>

    <!-- Azioni rapide -->
    <v-row class="mb-2">
      <v-col cols="12" md="4" v-if="puoScrivere">
        <v-card color="primary" theme="dark" class="rounded-lg" style="cursor:pointer" @click="vaiCalendario">
          <v-card-text class="text-center py-6">
            <v-icon size="36" class="mb-2">mdi-plus-circle</v-icon>
            <div class="text-subtitle-1 font-weight-bold">Nuova
              Manutenzione</div>
            <div class="text-caption" style="opacity:.85">Registra un nuovo
              intervento</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" :md="puoScrivere ? 4 : 6">
        <v-card variant="outlined" class="rounded-lg" style="cursor:pointer" @click="vaiStorico">
          <v-card-text class="text-center py-6">
            <v-icon size="36" class="mb-2" color="primary">mdi-history</v-icon>
            <div class="text-subtitle-1 font-weight-bold">Storico</div>
            <div class="text-caption text-medium-emphasis">Visualizza
              manutenzioni</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" :md="puoScrivere ? 4 : 6">
        <v-card variant="outlined" class="rounded-lg" style="cursor:pointer" @click="vaiMacchine">
          <v-card-text class="text-center py-6">
            <v-icon size="36" class="mb-2" color="primary">mdi-cog</v-icon>
            <div class="text-subtitle-1 font-weight-bold">Macchine</div>
            <div class="text-caption text-medium-emphasis">Gestione
              macchine</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Statistiche -->
    <h3 class="text-subtitle-1 font-weight-bold mb-2 d-flex align-center">
      <span class="ambito-dot bg-manutenzioni"></span>Manutenzioni
    </h3>
    <v-row class="mb-2">
      <v-col cols="6" md="3">
        <v-card variant="outlined" class="rounded-lg" height="100%">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="text-caption text-medium-emphasis">Manutenzioni
                  Totali</div>
                <div class="text-h4 font-weight-bold">{{ kpi.manutenzioniTotali
                  }}</div>
                <div class="text-caption text-medium-emphasis">Tutte le
                  manutenzioni</div>
              </div>
              <v-avatar color="blue-lighten-4" size="44">
                <v-icon color="primary">mdi-clipboard-list</v-icon>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" md="3">
        <v-card variant="outlined" class="rounded-lg" height="100%">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="text-caption text-medium-emphasis">Completate questo mese</div>
                <div class="text-h4 font-weight-bold">{{ kpi.manutenzioniCompletateMese }}</div>
                <div class="text-caption text-medium-emphasis">{{ meseCorrente }}</div>
              </div>
              <v-avatar color="green-lighten-4" size="44">
                <v-icon color="success">mdi-check-circle</v-icon>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" md="3">
        <v-card variant="outlined" class="rounded-lg" height="100%">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="text-caption text-medium-emphasis">Macchine Attive</div>
                <div class="text-h4 font-weight-bold">{{ kpi.macchineAttive }}</div>
                <div class="text-caption text-medium-emphasis">In produzione</div>
              </div>
              <v-avatar color="purple-lighten-4" size="44">
                <v-icon color="deep-purple">mdi-factory</v-icon>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" md="3">
        <v-card variant="outlined" class="rounded-lg" height="100%">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="text-caption text-medium-emphasis">Fermo Macchina </div>
                <div class="text-h4 font-weight-bold">{{
                  formattaTempoMedio(kpi.tempoMedioMinutiFermoMacchina) }}</div>
                <div class="text-caption text-medium-emphasis">{{ meseCorrente }}</div>
              </div>
              <v-avatar color="orange-lighten-4" size="44">
                <v-icon color="orange-darken-2">mdi-clock-outline</v-icon>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" md="3">
        <v-card variant="outlined" class="rounded-lg" height="100%" style="cursor:pointer" @click="vaiMagazzino">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="text-caption text-medium-emphasis">Stato Magazzino</div>
                <div class="text-h4 font-weight-bold"
                  :class="kpi.ricambiSottoScorta > 0 ? 'text-error' : 'text-success'">{{ kpi.ricambiSottoScorta
                  }}</div>
                <div class="text-caption text-medium-emphasis">{{ kpi.ricambiSottoScorta === 1 ?
                  'articolo sotto scorta' : 'articoli sotto scorta' }}</div>
              </div>
              <v-avatar :color="kpi.ricambiSottoScorta > 0 ? 'red-lighten-4' : 'green-lighten-4'" size="44">
                <v-icon :color="kpi.ricambiSottoScorta > 0 ? 'error' : 'success'">mdi-archive-alert</v-icon>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" md="3">
        <v-card variant="outlined" class="rounded-lg" height="100%" style="cursor:pointer" @click="vaiMacchine">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="text-caption text-medium-emphasis">Macchine in Manutenzione</div>
                <div class="text-h4 font-weight-bold">{{ kpi.macchineInManutenzione }}</div>
                <div class="text-caption text-medium-emphasis">Fermo in corso</div>
              </div>
              <v-avatar color="orange-lighten-4" size="44">
                <v-icon color="orange-darken-2">mdi-wrench-clock</v-icon>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Grafico per tipo + attività recente -->
    <v-row>
      <v-col cols="12" md="7">
        <v-card variant="outlined" class="rounded-lg" height="100%">
          <v-card-title>Manutenzioni per Tipo</v-card-title>
          <v-card-text>
            <div v-if="kpi.manutenzioniPerTipo.length === 0" class="text-center text-medium-emphasis pa-6">
              Nessuna manutenzione registrata.
            </div>
            <template v-else>
              <div style="height: 260px;">
                <canvas ref="chartTipo"></canvas>
              </div>
              <v-row class="mt-3" dense>
                <v-col v-for="t in kpi.manutenzioniPerTipo" :key="t.nome" cols="6" sm="4" class="d-flex align-center">
                  <v-icon :color="t.colore || 'grey'" size="10" class="mr-1">mdi-circle</v-icon>
                  <span class="text-caption text-truncate">{{ t.nome }} · {{
                    percentuale(t.conteggio) }}%</span>
                </v-col>
              </v-row>
            </template>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="5">
        <v-card variant="outlined" class="rounded-lg" height="100%">
          <v-card-title class="d-flex align-center justify-space-between">
            Ultime Manutenzioni
            <v-btn size="small" variant="text" color="primary" @click="vaiStorico">Vedi tutte</v-btn>
          </v-card-title>
          <v-list v-if="kpi.ultimeManutenzioni.length > 0" lines="two">
            <v-list-item v-for="m in kpi.ultimeManutenzioni" :key="m.id" style="cursor:pointer"
              @click="vaiMacchinaDettaglio(m.macchinaId)">
              <v-list-item-title class="font-weight-medium">{{ m.macchinaNome
                }}</v-list-item-title>
              <v-list-item-subtitle>{{ formattaData(m.data) }} · {{
                m.eseguitaDaNome || '—' }}</v-list-item-subtitle>
              <template #append>
                <v-chip size="small" :color="coloreStato(m.stato)" variant="flat">{{ m.tipoManutenzioneNome }}</v-chip>
              </template>
            </v-list-item>
          </v-list>
          <v-card-text v-else class="text-center text-medium-emphasis">
            Nessuna attività recente.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Mezzi -->
    <v-divider class="my-4" />
    <h3 class="text-subtitle-1 font-weight-bold mb-2 d-flex align-center">
      <span class="ambito-dot bg-mezzi"></span>Mezzi
    </h3>
    <v-row class="mb-2">
      <v-col cols="6" md="3">
        <v-card variant="outlined" class="rounded-lg" height="100%" style="cursor:pointer" @click="vaiMezzi">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="text-caption text-medium-emphasis">Mezzi Attivi</div>
                <div class="text-h4 font-weight-bold">{{ kpi.mezziAttivi }}</div>
                <div class="text-caption text-medium-emphasis">su {{ kpi.mezziTotali }} totali</div>
              </div>
              <v-avatar color="purple-lighten-4" size="44">
                <v-icon color="deep-purple">mdi-truck</v-icon>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" md="3">
        <v-card variant="outlined" class="rounded-lg" height="100%" style="cursor:pointer" @click="vaiMezzi">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="text-caption text-medium-emphasis">Mezzi in Manutenzione</div>
                <div class="text-h4 font-weight-bold">{{ kpi.mezziInManutenzione }}</div>
                <div class="text-caption text-medium-emphasis">Fermo in corso</div>
              </div>
              <v-avatar color="orange-lighten-4" size="44">
                <v-icon color="orange-darken-2">mdi-wrench-clock</v-icon>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" md="3">
        <v-card variant="outlined" class="rounded-lg" height="100%" style="cursor:pointer" @click="vaiMezzi">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="text-caption text-medium-emphasis">Scadenze Scadute</div>
                <div class="text-h4 font-weight-bold" :class="kpi.scadenzeMezzoScadute > 0 ? 'text-error' : 'text-success'">
                  {{ kpi.scadenzeMezzoScadute }}</div>
                <div class="text-caption text-medium-emphasis">Revisioni, bolli, assicurazioni…</div>
              </div>
              <v-avatar :color="kpi.scadenzeMezzoScadute > 0 ? 'red-lighten-4' : 'green-lighten-4'" size="44">
                <v-icon :color="kpi.scadenzeMezzoScadute > 0 ? 'error' : 'success'">mdi-alert-circle</v-icon>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" md="3">
        <v-card variant="outlined" class="rounded-lg" height="100%" style="cursor:pointer" @click="vaiMezzi">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="text-caption text-medium-emphasis">Scadenze nei prossimi 7gg</div>
                <div class="text-h4 font-weight-bold">{{ kpi.scadenzeMezzoProssimi7Giorni }}</div>
                <div class="text-caption text-medium-emphasis">Da pianificare</div>
              </div>
              <v-avatar color="blue-lighten-4" size="44">
                <v-icon color="primary">mdi-calendar-clock</v-icon>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Pagamenti/Incassi: riservato al ruolo Admin, come le rispettive pagine -->
    <template v-if="mostraFinanziario">
      <v-divider class="my-4" />
      <h3 class="text-subtitle-1 font-weight-bold mb-2 d-flex align-center">
        <span class="ambito-dot bg-amministrazione"></span>Pagamenti &amp; Incassi
      </h3>
      <v-row class="mb-2">
        <v-col cols="6" md="3">
          <v-card variant="outlined" class="rounded-lg" height="100%" style="cursor:pointer" @click="vaiPagamenti">
            <v-card-text>
              <div class="d-flex align-center justify-space-between">
                <div>
                  <div class="text-caption text-medium-emphasis">Da Pagare</div>
                  <div class="text-h5 font-weight-bold">{{ formattaImporto(kpi.pagamentiTotaleDaPagare) }}</div>
                  <div class="text-caption text-medium-emphasis">{{ kpi.pagamentiNumeroDaPagare }} pagamenti</div>
                </div>
                <v-avatar color="blue-lighten-4" size="44">
                  <v-icon color="primary">mdi-cash-clock</v-icon>
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6" md="3">
          <v-card variant="outlined" class="rounded-lg" height="100%" style="cursor:pointer" @click="vaiPagamenti">
            <v-card-text>
              <div class="d-flex align-center justify-space-between">
                <div>
                  <div class="text-caption text-medium-emphasis">Pagamenti Scaduti</div>
                  <div class="text-h5 font-weight-bold" :class="kpi.pagamentiNumeroScaduto > 0 ? 'text-error' : ''">
                    {{ formattaImporto(kpi.pagamentiTotaleScaduto) }}</div>
                  <div class="text-caption text-medium-emphasis">{{ kpi.pagamentiNumeroScaduto }} pagamenti</div>
                </div>
                <v-avatar :color="kpi.pagamentiNumeroScaduto > 0 ? 'red-lighten-4' : 'green-lighten-4'" size="44">
                  <v-icon :color="kpi.pagamentiNumeroScaduto > 0 ? 'error' : 'success'">mdi-alert-circle</v-icon>
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6" md="3">
          <v-card variant="outlined" class="rounded-lg" height="100%" style="cursor:pointer" @click="vaiIncassi">
            <v-card-text>
              <div class="d-flex align-center justify-space-between">
                <div>
                  <div class="text-caption text-medium-emphasis">Da Incassare</div>
                  <div class="text-h5 font-weight-bold">{{ formattaImporto(kpi.incassiTotaleDaIncassare) }}</div>
                  <div class="text-caption text-medium-emphasis">{{ kpi.incassiNumeroDaIncassare }} incassi</div>
                </div>
                <v-avatar color="blue-lighten-4" size="44">
                  <v-icon color="primary">mdi-cash-plus</v-icon>
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6" md="3">
          <v-card variant="outlined" class="rounded-lg" height="100%" style="cursor:pointer" @click="vaiIncassi">
            <v-card-text>
              <div class="d-flex align-center justify-space-between">
                <div>
                  <div class="text-caption text-medium-emphasis">Incassi Scaduti</div>
                  <div class="text-h5 font-weight-bold" :class="kpi.incassiNumeroScaduto > 0 ? 'text-error' : ''">
                    {{ formattaImporto(kpi.incassiTotaleScaduto) }}</div>
                  <div class="text-caption text-medium-emphasis">{{ kpi.incassiNumeroScaduto }} incassi</div>
                </div>
                <v-avatar :color="kpi.incassiNumeroScaduto > 0 ? 'red-lighten-4' : 'green-lighten-4'" size="44">
                  <v-icon :color="kpi.incassiNumeroScaduto > 0 ? 'error' : 'success'">mdi-alert-circle</v-icon>
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-card variant="outlined" class="rounded-lg" height="100%">
            <v-card-title class="d-flex align-center justify-space-between">
              Prossimi Pagamenti
              <v-btn size="small" variant="text" color="primary" @click="vaiPagamenti">Vedi tutti</v-btn>
            </v-card-title>
            <v-list v-if="kpi.prossimiPagamenti.length > 0" lines="two">
              <v-list-item v-for="p in kpi.prossimiPagamenti" :key="p.id" style="cursor:pointer" @click="vaiPagamenti">
                <v-list-item-title class="font-weight-medium">{{ p.controparte || '—' }}</v-list-item-title>
                <v-list-item-subtitle :class="p.effettivamenteScaduto ? 'text-error' : ''">
                  {{ formatSoloData(p.dataScadenza) }} · {{ p.tipoNome }}
                </v-list-item-subtitle>
                <template #append>
                  <span class="font-weight-medium">{{ formattaImporto(p.importo) }}</span>
                </template>
              </v-list-item>
            </v-list>
            <v-card-text v-else class="text-center text-medium-emphasis">
              Nessun pagamento in scadenza.
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card variant="outlined" class="rounded-lg" height="100%">
            <v-card-title class="d-flex align-center justify-space-between">
              Prossimi Incassi
              <v-btn size="small" variant="text" color="primary" @click="vaiIncassi">Vedi tutti</v-btn>
            </v-card-title>
            <v-list v-if="kpi.prossimiIncassi.length > 0" lines="two">
              <v-list-item v-for="i in kpi.prossimiIncassi" :key="i.id" style="cursor:pointer" @click="vaiIncassi">
                <v-list-item-title class="font-weight-medium">{{ i.controparte || '—' }}</v-list-item-title>
                <v-list-item-subtitle :class="i.effettivamenteScaduto ? 'text-error' : ''">
                  {{ formatSoloData(i.dataScadenza) }} · {{ i.tipoNome }}
                </v-list-item-subtitle>
                <template #append>
                  <span class="font-weight-medium">{{ formattaImporto(i.importo) }}</span>
                </template>
              </v-list-item>
            </v-list>
            <v-card-text v-else class="text-center text-medium-emphasis">
              Nessun incasso previsto.
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </template>

  <v-row v-else>
    <v-col cols="12" class="text-center pa-10">
      <v-progress-circular indeterminate color="primary" />
    </v-col>
  </v-row>
</v-container>